import { ViewModel,View } from "binder"
import  { AddNewInterfacePersonView } from "./addNewInterfacePerson-view"
import { InterfacePersonSearchViewModel } from "../interfacePersonSearch/interfacePersonSearch-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class AddNewInterfacePersonViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: ViewModel, customerId: string) {
        super(parentViewModel);
        this.customerId = customerId;
        this.interfacePersonsSelector = new InterfacePersonSearchViewModel(this, customerId);
        this.interfacePersonsSelector.onSelectionChanged = x=> {
            this.receiverId = x?.id;
            this.receiverName = x?.title;
            this.receiverComment = x?.comment;
            this.receiverPhone = x?.phone;
        };
    }
    GetDefaultView(): View <ViewModel> {
        return new AddNewInterfacePersonView();
    }
    public getTypeId(): string {
        return "VM-AE23622C-6D0C-4689-BD94-C0A1A9B44526"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set receiverId(v: string) { this._receiverId = v; } public get receiverId(): string { return this._receiverId;} private _receiverId: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName; } private _receiverName: string;
    public set receiverPhone(v: string) { this._receiverPhone = v; } public get receiverPhone(): string { return this._receiverPhone;} private _receiverPhone: string;
    public set receiverComment(v: string) { this._receiverComment = v; } public get receiverComment(): string { return this._receiverComment;} private _receiverComment: string;
    public set interfacePersonsSelector(v: InterfacePersonSearchViewModel) { this._interfacePersonsSelector = v; } public get interfacePersonsSelector(): InterfacePersonSearchViewModel { return this._interfacePersonsSelector;} private _interfacePersonsSelector: InterfacePersonSearchViewModel;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    
    verifyCreateReceiver():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.receiverPhone)){
            result.push('تلفن را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.receiverComment)){
            result.push('توضیحات را وارد کنید.')
        }
        if(stringIsNullOrEmpty(this.receiverName)){
            result.push('نام را وارد کنید.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verifyCreateReceiver();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت تحویل گیرنده');
                return;
            }
            this.isLoading = true;
            if (this.receiverId) {            
                let result = await ServerConnection.callServer('/Complex/CrmServices/UpdateCustomerInterface',{
                    Id:this.receiverId,
                    CustomerId:this.customerId,
                    Name:'',
                    Lastname:this.receiverName,
                    PhoneNumber:this.receiverPhone,
                    Comment:this.receiverComment
                });
                this.receiverId = result.InterfaceId;
                await this.messageBoxConfirmSuccess('تحویل گیرنده با موفقیت بروز شد.','عملیات موفق');
            } else {
                let result = await ServerConnection.callServer('/Complex/CrmServices/CreateInterfacePerson',{
                    Name:'',
                    CustomerId:this.customerId,
                    Lastname:this.receiverName,
                    PhoneNumber:this.receiverPhone,
                    Comment:this.receiverComment
                });
                this.receiverId = result.InterfaceId;
                await this.messageBoxConfirmSuccess('تحویل گیرنده با موفقیت ثبت شد.','عملیات موفق');
            }
            this.closePopup("done");

        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    closePopup(resultCode: string = null) {
        if (resultCode == "done")
            return true;
        return false;
    }
}
